// space between the image thumbnail
export const GUTTER_SIZE = 18;
export const THUMBNAIL_WIDTH = 150;

// For user uploaded images
export const THUMBNAIL_HEIGHT = 135;

// number of columns on the list view
export const COLUMN_NUM = 2;

// Offset of the image index that trigger load more funciton
export const INDEX_OFFSET = 10;
